import React from 'react'

import { SxProps } from '@mui/material'

import { useQuery } from 'utils/hooks'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Emoji from 'components_new/atoms/Emoji'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'
import { useTranslation } from 'language/translator'

interface Props {
  search?: string | null
  sx?: SxProps
}

const Empty = (props: Props) => {
  const { search, sx } = props

  const { t } = useTranslation()
  const { setQuery } = useQuery()

  const handleReset = () => {
    setQuery({ search: null })
  }

  // Zero results with no active search term means there is nothing to
  // clear - the metrics were filtered out by compatibility rules or an
  // empty category, not by a search that didn't match anything.
  if (!search) {
    return (
      <Box sx={sx}>
        <EmptyPlaceholder
          background={true}
          height={512}
          size="medium"
          title={t('metrics', 'no_metrics_available')}
        />
      </Box>
    )
  }

  return (
    <Box sx={sx}>
      <EmptyPlaceholder
        actions={
          <Button onClick={handleReset}>{t('global', 'clear_search')}</Button>
        }
        background={true}
        height={512}
        size="medium"
        title={
          <>
            {t('metrics', 'no_metrics_match')} &quot;{search}&quot;.{' '}
            <Emoji name={'mag'} />
          </>
        }
      />
    </Box>
  )
}

export default Empty
